import { useMemo } from "react";
import { Ghost } from "lucide-react";

export const Bat = ({ className, style }) => (
  <svg viewBox="0 0 64 24" className={className} style={style} fill="currentColor" aria-hidden="true">
    <g className="animate-wings">
      <path d="M32 11C28 3 19-1 7 1c6 4 9 8 7 12 6-2 12-2 18 2 6-4 12-4 18-2-2-4 1-8 7-12C45-1 36 3 32 11Z" />
    </g>
  </svg>
);

const PARTICLE_COLORS = ["#B6FF00", "#FF6B00", "#A020F0"];

export const SpookyLayer = () => {
  const particles = useMemo(
    () =>
      Array.from({ length: 26 }, (_, i) => ({
        id: i,
        left: `${(i * 37 + 13) % 100}%`,
        top: `${(i * 53 + 7) % 100}%`,
        size: 3 + ((i * 7) % 5),
        delay: `${(i % 9) * 0.45}s`,
        duration: `${2.4 + (i % 5) * 0.9}s`,
        color: PARTICLE_COLORS[i % 3],
      })),
    []
  );

  return (
    <div className="fixed inset-0 pointer-events-none z-0 overflow-hidden" aria-hidden="true" data-testid="spooky-layer">
      <div className="blob w-[55vw] h-[55vw] bg-[#19002E] opacity-70 -top-[20vw] -left-[15vw]" />
      <div className="blob w-[40vw] h-[40vw] bg-[#A020F0] opacity-[0.14] top-[35%] -right-[18vw]" />
      <div className="blob w-[45vw] h-[45vw] bg-[#FF6B00] opacity-[0.08] bottom-[-15%] left-[10%]" />

      {particles.map((p) => (
        <span
          key={p.id}
          className="absolute rounded-full animate-twinkle"
          style={{
            left: p.left,
            top: p.top,
            width: p.size,
            height: p.size,
            backgroundColor: p.color,
            boxShadow: `0 0 10px ${p.color}`,
            animationDelay: p.delay,
            animationDuration: p.duration,
          }}
        />
      ))}

      <Ghost className="absolute text-[#B6FF00]/25 animate-float w-10 h-10 top-[22%] left-[6%]" style={{ animationDelay: "0.4s" }} />
      <Ghost className="absolute text-[#A020F0]/30 animate-float w-14 h-14 top-[58%] right-[7%]" style={{ animationDelay: "1.6s" }} />
      <Ghost className="absolute text-[#FF6B00]/20 animate-float w-8 h-8 bottom-[14%] left-[16%]" style={{ animationDelay: "2.8s" }} />

      <Bat className="absolute text-[#A020F0]/50 w-12 animate-bat top-[12%]" />
      <Bat className="absolute text-[#B6FF00]/40 w-8 animate-bat top-[38%]" style={{ animationDelay: "9s", animationDuration: "32s" }} />
      <Bat className="absolute text-[#FF6B00]/45 w-10 animate-bat top-[70%]" style={{ animationDelay: "18s", animationDuration: "28s" }} />
    </div>
  );
};
